import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { Divider, Layout, Menu, Popover, Dropdown, Modal, Button } from "antd";
import HbgHeader from "@huobi-fed-global/fed-responsive-header/lib/react/header";
import type { MenuProps } from "antd";
import logo from "../logo.svg";
import userphoto from "../assets/icons/user.png";
import "../assets/less/header.less";
import "@huobi-fed-global/fed-responsive-header/lib/styles/index.css";
import { $t } from "@/i18n";
import { apiUc } from "@/services/api.uc";
import cookie from "js-cookie";
import { i18nList } from "@/util/config";
import { apiNft } from "@/services/api.nft";
import { useTranslation } from "react-i18next";
import { IsRender } from "@/componments/is-render";
import NormalOne from "../assets/icons/normal-one.svg";
import { apiInvite } from "@/services/api.invite";
import cookies from "js-cookie";
import { useUserInfo } from "@/hooks/user.hook";
import { parse } from "querystring";
import { OpenBoxCard } from "./OpenBoxCard";
import { MutiModal } from "./MutiModal";
import { apiGiftbox } from "../services/api.giftbox";
import FirstSuccessIcon from "@/assets/images/firstSuccessIcon.png";

const { Sider, Content } = Layout;

export const HbHeader = function HbHeader() {
  const { LANG } = useParams();
  const location = useLocation();
  const [hovered, setHovered] = useState<boolean>(false);
  const { userInfo, hasUc } = useUserInfo();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const subUid = query.get("subUid") || "";

  const param: any = parse(window.location.search.slice(1));
  const invite_code_special = param.invite_code || "";

  const codeFind = "crm_token" + invite_code_special;
  const crm_token =
    cookies.get(codeFind) || sessionStorage.getItem(codeFind) || "1155555";
  const [langList, setLangList] = useState<Array<string>>([]);
  useEffect(() => {
    apiInvite.checkKoreanKol().then(({ data }) => {
      const arr = Object.keys(i18nList);
      if (data) {
        setLangList(arr);
      } else {
        setLangList(arr.filter((v) => v !== "ko-kr"));
      }
    });
  }, [i18nList]);

  return (
    <div className="hb-header">
      <div className="header-body">
        <nav className="header-nav">
          <a href="/" className="header-nav-brand">
            <img src={logo} alt="logo" className="header-nav-logo" />
          </a>
          <div className="header__menu">
            <div className="newmenu mgr-8">
              <Menu mode="horizontal" className="coolMenu">
                <Menu.SubMenu
                  key="SubMenu"
                  title={$t("{#买币#}")}
                  icon={<i className="icon-one-spe" />}
                >
                  <Menu.Item
                    key="one-one"
                    icon={<i className="icon-one-one" />}
                    onClick={() =>
                      (window.location.href = `/${LANG}/fiat-crypto/one-trade/buy-usdt-usd`)
                    }
                  >
                    {$t("{#快捷一键买卖#}")}
                  </Menu.Item>
                  <Menu.Item
                    key="one-two"
                    icon={<i className="icon-one-two" />}
                    onClick={() =>
                      (window.location.href = `/${LANG}/fiat/deposit/?currency=try`)
                    }
                  >
                    {$t("{#法币充值#}")}
                  </Menu.Item>
                  <Menu.Item
                    key="one-three"
                    icon={<i className="icon-one-three" />}
                    onClick={() =>
                      (window.location.href = `/${LANG}/fiat-crypto/trade/buy-usdt`)
                    }
                  >
                    {$t("{#P2P自选交易#}")}
                  </Menu.Item>
                </Menu.SubMenu>

                <Menu.SubMenu
                  key="SubTwoMenu"
                  title={$t("{#行情#}")}
                  icon={<i className="icon-two-spe" />}
                >
                  <Menu.Item
                    key="two-one"
                    icon={<i className="icon-two-one" />}
                    onClick={() =>
                      (window.location.href = `/${LANG}/markets/?tab=fav`)
                    }
                  >
                    {$t("{#自选#}")}
                  </Menu.Item>
                  <Menu.Item
                    key="two-two"
                    icon={<i className="icon-two-two" />}
                    onClick={() =>
                      (window.location.href = `/${LANG}/markets/?tab=exchange`)
                    }
                  >
                    {$t("{#现货#}")}
                  </Menu.Item>
                  <Menu.Item
                    key="two-three"
                    icon={<i className="icon-two-three" />}
                    onClick={() =>
                      (window.location.href = `/${LANG}/markets/?tab=dm`)
                    }
                  >
                    {$t("{#合约#}")}
                  </Menu.Item>
                </Menu.SubMenu>

                <Menu.SubMenu
                  key="SubThreeMenu"
                  title={$t("{#现货交易#}")}
                  icon={<i className="icon-three-spe" />}
                >
                  <Menu.Item
                    key="three-one"
                    icon={<i className="icon-three-one" />}
                    onClick={() =>
                      (window.location.href = `/${LANG}/exchange/`)
                    }
                  >
                    {$t("{#币币交易#}")}
                  </Menu.Item>
                  <Menu.Item
                    key="three-two"
                    icon={<i className="icon-three-two" />}
                    onClick={() =>
                      (window.location.href = `/${LANG}/cross-margin/`)
                    }
                  >
                    {$t("{#全仓杠杆#}")}
                  </Menu.Item>
                  <Menu.Item
                    key="three-three"
                    icon={<i className="icon-three-three" />}
                    onClick={() => (window.location.href = `/${LANG}/margin/`)}
                  >
                    {$t("{#逐仓杠杆#}")}
                  </Menu.Item>
                  <Menu.Item
                    key="three-four"
                    icon={<i className="icon-three-four" />}
                    onClick={() =>
                      (window.location.href = `/${LANG}/grid-exchange/`)
                    }
                  >
                    {$t("{#Tradingbot 策略交易#}")}
                  </Menu.Item>
                </Menu.SubMenu>

                <Menu.SubMenu
                  key="SubFourMenu"
                  title={$t("{#合约交易#}")}
                  icon={<i className="icon-four-spe" />}
                >
                  <Menu.Item
                    key="four-one"
                    icon={<i className="icon-four-one" />}
                    onClick={() =>
                      (window.location.href = `/${LANG}/markets/?tab=fav`)
                    }
                  >
                    {$t("{#U本位合约#}")}
                  </Menu.Item>
                  <Menu.Item
                    key="four-two"
                    icon={<i className="icon-four-two" />}
                    onClick={() =>
                      (window.location.href = `/${LANG}/markets/?tab=exchange`)
                    }
                  >
                    {$t("{#币本位交割#}")}
                  </Menu.Item>
                  <Menu.Item
                    key="four-three"
                    icon={<i className="icon-four-three" />}
                    onClick={() =>
                      (window.location.href = `/${LANG}/markets/?tab=dm`)
                    }
                  >
                    {$t("{#币本位永续#}")}
                  </Menu.Item>
                  <Menu.Item
                    key="four-four"
                    icon={<i className="icon-four-four" />}
                    onClick={() =>
                      (window.location.href = `/${LANG}/markets/?tab=dm`)
                    }
                  >
                    {$t("{#期权交易#}")}
                  </Menu.Item>
                  <Menu.Item
                    key="four-five"
                    icon={<i className="icon-four-five" />}
                    onClick={() =>
                      (window.location.href = `/${LANG}/markets/?tab=dm`)
                    }
                  >
                    {$t("{#合约跟单#}")}
                  </Menu.Item>
                </Menu.SubMenu>

                <Menu.SubMenu
                  key="SubFiveMenu"
                  title={$t("{#金融服务#}")}
                  icon={<i className="icon-five-spe" />}
                >
                  <Menu.ItemGroup
                    title={$t("{#理财相关#}")}
                    className="menu-group"
                  >
                    <Menu.Item
                      key="five-one"
                      icon={<i className="icon-five-one" />}
                      onClick={() =>
                        (window.location.href = `/${LANG}/financial/earn/`)
                      }
                    >
                      {$t("{#Huobi Earn 理财#}")}
                    </Menu.Item>
                    <Menu.Item
                      key="five-two"
                      icon={<i className="icon-five-two" />}
                      onClick={() =>
                        (window.location.href = `/${LANG}/otc-option/exchange/#btc_usdt`)
                      }
                    >
                      {$t("{#双币投资#}")}
                    </Menu.Item>
                    <Menu.Item
                      key="five-three"
                      icon={<i className="icon-five-three" />}
                      onClick={() =>
                        (window.location.href = `/${LANG}/financial/pledge/`)
                      }
                    >
                      {$t("{#质押借币#}")}
                    </Menu.Item>
                  </Menu.ItemGroup>
                  <Menu.ItemGroup title={$t("{#其他#}")} className="menu-group">
                    <Menu.Item
                      key="five-four"
                      icon={<i className="icon-five-four" />}
                      onClick={() =>
                        (window.location.href = `/${LANG}/staking/vote/`)
                      }
                    >
                      {$t("{#节点质押投票#}")}
                    </Menu.Item>
                    <Menu.Item
                      key="five-five"
                      icon={<i className="icon-five-five" />}
                      onClick={() =>
                        (window.location.href = `/${LANG}/staking/eth2/`)
                      }
                    >
                      {$t("{#ETH2.0#}")}
                    </Menu.Item>
                    <Menu.Item
                      key="five-six"
                      icon={<i className="icon-five-six" />}
                      onClick={() =>
                        (window.location.href = `https://www.huobi-brokerage.com/zh-hk/lending/order`)
                      }
                    >
                      {$t("{#借贷业务系统#}")}
                    </Menu.Item>
                    <Menu.Item
                      key="five-seven"
                      icon={<i className="icon-five-seven" />}
                      onClick={() =>
                        (window.location.href = `https://www.huobi-brokerage.com/zh-hk/trade`)
                      }
                    >
                      {$t("{#OTC交易系统#}")}
                    </Menu.Item>
                  </Menu.ItemGroup>
                </Menu.SubMenu>

                <Menu.Item
                  key="SubSixMenu"
                  icon={<i className="icon-six-spe" />}
                  onClick={() =>
                    (window.location.href = `/${LANG}/welfare/web/`)
                  }
                >
                  {$t("{#福利中心#}")}
                </Menu.Item>
              </Menu>
            </div>
          </div>
        </nav>
        <div className="header__user">
          <div className="header__user__body">
            <div className="header__user__body__my">
              <div className="header__user__body__item">
                <div className="icon-user">
                  <img
                    src={userphoto}
                    alt=""
                    style={{ width: "24px", height: "24px" }}
                  />
                </div>
                <span style={{ marginLeft: "8px" }}>
                  UID：{subUid ? subUid : userInfo.uid}
                </span>
              </div>
            </div>

            <div className="header__user__body__extra">
              <div className="hb-lang-change">
                <Popover
                  placement="bottomRight"
                  // title={$t("{#语言#}")}
                  visible={hovered}
                  trigger="hover"
                  onVisibleChange={(v) => setHovered(v)}
                  content={
                    <div className="max-h400 lang-list">
                      {langList.map((v) => (
                        <div
                          className={`langcur line-h32 ${
                            v === LANG ? "active" : ""
                          }`}
                          key={v}
                          onClick={() => {
                            setHovered(false);
                            window.location.href = `${
                              window.location.origin
                            }/${v}${
                              location.pathname.split(LANG || "")[1] ||
                              location.pathname
                            }?crm_token=${crm_token}&invite_code=${invite_code_special}`;
                          }}
                        >
                          <span className="shortening">
                            {v.split("-")[0] === "zh" ||
                            v.split("-")[0] === "es" ||
                            v.split("-")[0] === "pt"
                              ? v.split("-")[1].toUpperCase()
                              : v.split("-")[0].toUpperCase()}
                          </span>
                          <span>{i18nList[v]}</span>
                        </div>
                      ))}
                    </div>
                  }
                >
                  <div className="langchoose"></div>
                  {/* {i18nList[LANG || "en-us"]} */}
                </Popover>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export function PcLayout() {
  const { LANG } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuActive, setMenuActive] = useState("invite-dashboard");
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const [t, i18n] = useTranslation();
  const [isWhiteListUser, setIsWhiteListUser] = useState<boolean>(false);
  const [collapsed, setCollapsed] = useState(false);
  const [isKol, setIsKol] = useState<boolean>(false);
  const [primeBoxShow, setPrimeBoxShow] = useState<boolean>(false);

  const { userInfo, hasUc } = useUserInfo();
  const param: any = parse(window.location.search.slice(1));
  const invite_code_special = param.invite_code || "";

  const codeFind = "crm_token" + invite_code_special;
  const crm_token =
    cookies.get(codeFind) || sessionStorage.getItem(codeFind) || "";
  const onLocale = (event, locale) => {
    if (crm_token) {
      window.location.href = `${window.location.origin}/${locale}${
        location.pathname.split(LANG || "")[1] || location.pathname
      }?crm_token=${crm_token}&invite_code=${invite_code_special}`;
    } else {
      window.location.href = `${window.location.origin}/${locale}${
        location.pathname.split(LANG || "")[1] || location.pathname
      }`;
    }
    if (location?.pathname?.split("/").slice(-1)[0] === "invite-statistics") {
      setMenuActive("invite-dashboard");
    }
  };
const onregister = (event: MouseEvent, url: string)=>{
            console.log('onregister', event, url);
       const locale = LANG || 'en-us';
         window.location.href = `/${LANG}/register?backUrl=${encodeURIComponent(
          window.location.href.replace(window.location.origin, "")
        )}`;
        console.log('redirect to register',`/${LANG}/register?backUrl=${encodeURIComponent(
          window.location.href.replace(window.location.origin, "")
        )}`);
        // window.location.href = `${window.location.origin}/${locale}${
    // router.push(`/${currentLocale}/register/?backUrl=${encodeURIComponent(router.asPath)}`);
}
  const hostname = () => {
    return window.location.host;
  };

  const onLogout = (event, url) => {
    // window.location.href = `/${ LANG }/login?backUrl=${encodeURIComponent(window.location.href.replace(window.location.origin, ''))}`
    apiUc.ucLogout().then(async (res) => {
      // console.log(res)
      if (res.success) {
        // window.location.reload();
        window.location.href = `/${LANG}/login`;
      }
    });
  };

  const toggleCollapsed = () => {
    //   console.log(collapsed)
    setCollapsed(!collapsed);
  };

  const [menuList, setMenuList] = useState<MenuProps["items"]>([]);
  type MenuItem = Required<MenuProps>["items"][number];

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group"
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }

  let _menuList: MenuItem[] = [];

  const getMenu = async () => {
    const [
      { data: dataMutiFlag },
      { data: dataIsWhiteListUser },
      { data: dataCheckKol },
      { data: dataCurrentUid },
      { data: subUserList },
      { data: giftboxCount },
    ] = await Promise.all([
      apiInvite.mutiFlag(),
      apiInvite.isWhiteListUser(),
      apiInvite.checkKol(),
      apiInvite.currentUid(),
      apiInvite.subUserList(),
      apiGiftbox.getGiftboxCount(),
    ]);
    // console.log('subUserList is',subUserList,subUserList_1.length === 0)
    // console.log('giftboxCount is ',giftboxCount)
    setIsWhiteListUser(dataIsWhiteListUser);
    if (dataIsWhiteListUser) {
      _menuList = [
        getItem(
          $t("{#仪表盘#}"),
          "invite-dashboard",
          menuActive === "invite-dashboard" ||
            menuActive === "invite-statistics" ? (
            <img
              className="leftactiveone"
              src={require("@/assets/icons/KOL.png")}
              alt=""
              //@ts-ignore
              async
              importance="high"
            />
          ) : (
            <i className="leftone" />
          )
        ),
        getItem(
          $t("{#邀请人_T383788_1#}"),
          "invite-user",
          menuActive === "invite-user" ? (
            <img
              className="leftactiveone"
              src={require("@/assets/icons/i2.png")}
              alt=""
              //@ts-ignore
              async
              importance="high"
            />
          ) : (
            <i className="lefttwo" />
          )
        ),
        getItem(
          $t("{#合伙人_T383788_1#}"),
          "invite-partner",
          menuActive === "invite-partner" ? (
            <img
              className="leftactiveone"
              src={require("@/assets/icons/i3.png")}
              alt=""
              //@ts-ignore
              async
              importance="high"
            />
          ) : (
            <i className="leftthree" />
          )
        ),
        getItem(
          $t("{#合约交易#}"),
          "invite-trading",
          menuActive === "invite-current" || menuActive === "invite-history" ? (
            <img
              className="leftactiveone"
              src={require("@/assets/icons/i5.png")}
              alt=""
              //@ts-ignore
              async
              importance="high"
            />
          ) : (
            <i className="leftfour" />
          ),
          [
            getItem($t("{#当前持仓#}"), "invite-current"),
            getItem($t("{#委托历史#}"), "invite-history"),
          ]
        ),
        getItem(
          $t("{#现货交易#}"),
          "invite-spot-trading",
          menuActive === "spot-invite-current" ||
            menuActive === "spot-invite-history" ? (
            <img
              className="leftactiveone"
              src={require("@/assets/icons/i4.png")}
              alt=""
              //@ts-ignore
              async
              importance="high"
            />
          ) : (
            <i className="leftfive" />
          ),
          [
            getItem($t("{#当前持仓#}"), "spot-invite-current"),
            getItem($t("{#委托历史#}"), "spot-invite-history"),
          ]
        ),
        getItem(
          $t("{#奖励管理#}"),
          "invite-commission",
          menuActive === "invite-commission" ? (
            <img
              className="leftactiveone"
              src={require("@/assets/icons/i6.png")}
              alt=""
              //@ts-ignore
              async
              importance="high"
            />
          ) : (
            <i className="leftsix" />
          )
        ),
        getItem(
          $t("{#Fund#}"),
          "Fund",
          menuActive === "Fund" ? (
            <i className="left-icon-fun-active" />
          ) : (
            <i className="left-icon-fund" />
          )
        ),
      ];
    } else {
      _menuList = [
        getItem(
          $t("{#仪表盘#}"),
          "invite-dashboard",
          menuActive === "invite-dashboard" ||
            menuActive === "invite-statistics" ? (
            <img
              className="leftactiveone"
              src={require("@/assets/icons/KOL.png")}
              alt=""
              //@ts-ignore
              async
              importance="high"
            />
          ) : (
            <i className="leftone" />
          )
        ),
        getItem(
          $t("{#邀请人_T383788_1#}"),
          "invite-user",
          menuActive === "invite-user" ? (
            // <img src={ActiveTwo} alt={$t("{#邀请人_T383788_1#}")} />
            <img
              className="leftactiveone"
              src={require("@/assets/icons/i2.png")}
              alt=""
              //@ts-ignore
              async
              importance="high"
            />
          ) : (
            <i className="lefttwo" />
          )
        ),
        getItem(
          $t("{#合伙人_T383788_1#}"),
          "invite-partner",
          menuActive === "invite-partner" ? (
            <img
              className="leftactiveone"
              src={require("@/assets/icons/i3.png")}
              alt=""
              //@ts-ignore
              async
              importance="high"
            />
          ) : (
            <i className="leftthree" />
          )
        ),

        getItem(
          $t("{#奖励管理#}"),
          "invite-commission",
          menuActive === "invite-commission" ? (
            <img
              className="leftactiveone"
              src={require("@/assets/icons/i6.png")}
              alt=""
              //@ts-ignore
              async
              importance="high"
            />
          ) : (
            <i className="leftsix" />
          )
        ),
      ];
    }
    if (dataMutiFlag) {
      // pass
    } else {
      const partnerIndex = _menuList.findIndex((item) => {
        return item?.key === "invite-partner";
      });
      _menuList.splice(partnerIndex, 1);
    }

    await apiInvite.checkKol().then(({ code, data }) => {
      const isExist = _menuList.findIndex((item) => {
        return item?.key === "myreferral";
      });
      setIsKol(data && data.inviter_flag === 1);
      // console.log('dataMutiFlag is',dataMutiFlag)
      if (data && data.inviter_flag !== 1 && !dataMutiFlag && isExist === -1) {
        const myreferrals = getItem(
          $t("{#My Referrals#}"),
          "myreferral",
          menuActive === "myreferral" ? (
            <img
              className="leftactiveone"
              src={require("@/assets/icons/i7.png")}
              alt=""
              //@ts-ignore
              async
              importance="high"
            />
          ) : (
            <i className="leftgift" />
          )
        );
        _menuList.push(myreferrals);
      } else if (
        data &&
        (data.inviter_flag === 1 || dataMutiFlag) &&
        giftboxCount?.total > 0 &&
        isExist === -1
      ) {
        const myreferrals = getItem(
          $t("{#盲盒活动#}"),
          "myreferral",
          menuActive === "myreferral" ? (
            <img
              className="leftactiveone"
              src={require("@/assets/icons/i7.png")}
              alt=""
              //@ts-ignore
              async
              importance="high"
            />
          ) : (
            <i className="leftgift" />
          )
        );
        _menuList.push(myreferrals);
      }
    });
    setMenuList(_menuList);
  };

  let openBoxCardMock = {
    // boxCardData: {
    //   red_pocket_num: 2,
    //   invitee_names: ['153****23', '153****22'],
    //   cards: [
    //     {
    //       user_card_id: 1,
    //       card_rank: 1,
    //       card_type: 1,
    //       card_name: 'whale',
    //       card_item: 'BTC',
    //     },
    //     {
    //       user_card_id: 2,
    //       card_rank: 2,
    //       card_type: 2,
    //       card_name: 'yieldFarmer',
    //       card_item: 'ETH',
    //     },
    //     {
    //       user_card_id: 3,
    //       card_rank: 3,
    //       card_type: 3,
    //       card_name: 'bountyHunter',
    //       card_item: 'ETH',
    //     },
    //     {
    //         user_card_id: 2,
    //         card_rank: 2,
    //         card_type: 2,
    //         card_name: 'yieldFarmer',
    //         card_item: 'ETH',
    //       },
    //       {
    //         user_card_id: 3,
    //         card_rank: 3,
    //         card_type: 3,
    //         card_name: 'bountyHunter',
    //         card_item: 'ETH',
    //       },
    //       {
    //         user_card_id: 3,
    //         card_rank: 3,
    //         card_type: 3,
    //         card_name: 'bountyHunter',
    //         card_item: 'ETH',
    //       },
    //   ],
    //   cardTickets: [],
    // },
    // showOpenBoxCard: true,
    // isLogin: true,
    isPrimeBoxShow: true,
  };

  const onClick: MenuProps["onClick"] = (e) => {
    const search = location?.search;
    const link = `/${LANG}/statistics/${e.key}${search}`;
    navigate(link, { replace: true });
    setMenuActive(e.key);
    if (e.key === "invite-gift") {
      //@ts-ignore
      window.sensors.track("webclick_pc_activity", {
        business_category: "invite_dashboard",
        button_name: "invite_dashboard_mygift",
      });
    }
  };

  useEffect(() => {
    //   console.log(userInfo)
    getMenu();
    setMenuActive(location?.pathname?.split("/")?.slice(-1)[0] || "");
    if (location?.pathname?.split("/").slice(-1)[0] === "invite-statistics") {
      setMenuActive("invite-dashboard");
    }
  }, [location]);

  useEffect(() => {
    getMenu();
    // apiInvite.getStage().then(({ data }) => {
    //     // console.log(data)
    //     setPrimeBoxShow(data?.status === 2);
    //     // setPrimeBoxShow(true);
    // });
  }, [menuActive]);

  useEffect(() => {
    //从crm跳过来的绕过登录逻辑
    const param: any = parse(window.location.search.slice(1));
    const invite_code_special = param.invite_code || "";
    const codeFind = "crm_token" + invite_code_special;
    if (cookies.get(codeFind) || sessionStorage.getItem(codeFind)) {
      setIsLogin(true);
      return;
    }
    // toDo 登录态还没有集成
    i18n.on("languageChanged", (lang) => {
      setMenuList([
        {
          label: <>{$t("{#仪表盘#}")}</>,
          key: "invite-dashboard",
          icon: <img src={NormalOne} alt="" />,
        },
      ]);
    });
    apiUc.checkLogin().then(async (res) => {
      if (res.code === 200 && !cookie.get("HB-PRO-TOKEN")) {
        const { data } = await apiUc.getTicket();
        const pro = await apiUc.proLogin({ ticket: data.ticket });
        if (pro.data?.token) {
          cookie.set("HB-PRO-TOKEN", pro.data.token, {
            expires: new Date(+new Date() + 120000),
          });
          sessionStorage.setItem("HB-PRO-TOKEN", pro.data.token);
        }
      }
      if (res.code === 200 && !cookie.get("NFT-AUTH-TOKEN")) {
        const { data } = await apiUc.getTicket();
        const nft = await apiNft.nftLogin({ ticket: data.ticket });
        if (nft.data?.token) {
          cookie.set("NFT-AUTH-TOKEN", nft.data.token, {
            expires: new Date(+new Date() + 120000),
          });
          sessionStorage.setItem("NFT-AUTH-TOKEN", nft.data.token);
        }
      }
      if (res.code !== 200) {
        cookie.remove("NFT-AUTH-TOKEN");
        cookie.remove("HB-PRO-TOKEN");
        window.location.href = `/${LANG}/login?backUrl=${encodeURIComponent(
          window.location.href.replace(window.location.origin, "")
        )}`;
      }
      setIsLogin(res.code === 200);
      // setIsLogin(true);
    });
  }, []);

  const FirstSuccessModal = () => {
    const [show, setShow] = useState<boolean>(false);
    const [userType, setUserType] = useState<number>(0); // 0散户 1kol/多级

    useEffect(() => {
      apiInvite.getSasRebate({}).then((res) => {
        setShow(res.data.pop_flag === 1);
        setUserType(res.data.user_type);
      });
    }, []);

    const text = $t("{#可在<span>「我的邀请奖励-奖励管理」</span>查看奖励记录#}")

    const hideModal = () => {
      setShow(false);
    };

    const handlerView = () => {
      hideModal();
      navigate(`/${LANG}/statistics/invite-commission`);
    };

    return (
      <Modal
        width={"480px"}
        className="firstSuccessModal"
        onCancel={() => setShow(false)}
        onOk={() => setShow(false)}
        visible={show}
        footer={null}
      >
        <div className="firstSuccessWrap">
          <div className="firstSuccessTitle">{$t("{#恭喜您#}")}</div>
          <div className="firstSuccessTitle2">{$t("{#首次获得交易奖励#}")}</div>
          <img src={FirstSuccessIcon} alt="" className="firstSuccessIcon" />
          <div
            className="firstSuccessDesc"
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>
          <div className="btns">
            <Button onClick={hideModal}>{$t("{#我知道了#}")}</Button>
            <Button type="primary" onClick={handlerView}>
              {$t("{#立即查看#}")}
            </Button>
          </div>
        </div>
      </Modal>
    );
  };
   // @ts-ignore
  const windowProxy = window.unionHeaderConfigProxy ||
      new Proxy(window, {
        set(target, prop, value) {
          if (prop === 'unionHeaderConfig') {
            console.log('enhome, dispatchEvent unionHeaderConfigChange time ====> ', +new Date())
            const event = new Event('unionHeaderConfigChange')
            window.dispatchEvent(event)
          }
          target[prop] = value
          return true
        },
   })
   // @ts-ignore
  useEffect(() => {
    const config = {
      hostname:hostname(),
      theme: 'dark',
      userinfo:userInfo,
       onlocale:onLocale,
       active:"active",
       onlogout:onLogout,
       locales:LANG,
       locale:LANG,
       onregister:onregister,
    }
     const header = document.getElementById('unionjs-header')
      // @ts-ignore
    if (header && window.union && window.union?.use) {
      // @ts-ignore
      window.union.use("header",config); // @ts-ignore
      // console.log("use", window.union, "window.unionwindow.unionwindow.union");
    } else {
      windowProxy.unionHeaderConfig = config
    }
  }, 
  [hostname]
)
  return (
    <IsRender rIf={isLogin}>
      <Layout
        style={
          crm_token
            ? { minHeight: "100vh", paddingTop: "64px" }
            : { minHeight: "100vh" }
        }
      >
        <div id="unionjs-header" style={{ height: '64px', backgroundColor: '#161616' }}></div> 
          {/* <HbHeader />
        {crm_token ? (
          <HbHeader />
        ) : (
          //@ts-ignore
          <HbgHeader
            theme={"dark"}
            //@ts-ignore
            userinfo={userInfo}
            onlocale={onLocale}
            active="active"
            hostname={hostname()}
            onlogout={onLogout}
            locale={LANG}
          />
        )} */}
        <Layout>
          <Sider
            theme="light"
            className="hb-menu special-menu"
            collapsed={collapsed}
          >
            <Menu
              onClick={onClick}
              defaultSelectedKeys={[menuActive]}
              selectedKeys={[menuActive]}
              mode="inline"
              items={menuList}
            />
            <div className="pucker">
              <div
                className={collapsed ? "menuarrowgo" : "menuarrowback"}
                onClick={toggleCollapsed}
              ></div>
            </div>
          </Sider>

          <Content className="hb-content">
            <Outlet />
            {primeBoxShow && (
              <OpenBoxCard
                taskType={3}
                {...openBoxCardMock}
                isLogin
                isPc={true}
                isDefaultPcStyle={true}
                eventName={"webclick_pc_activity"}
                eventParams={{
                  business_category: "invite_dashboard",
                  button_name: "invite_dashboard_bubble",
                }}
                feventName={"webclick_pc_activity"}
                feventParams={{
                  business_category: "invite_dashboard",
                  button_name: "invite_dashboard_side",
                }}
              ></OpenBoxCard>
            )}
          </Content>
        </Layout>
        <MutiModal />
        {FirstSuccessModal()}
      </Layout>
    </IsRender>
  );
}
